import { ArrowRightStartOnRectangleIcon, ChevronUpIcon, Cog6ToothIcon, WrenchScrewdriverIcon, MoonIcon, SunIcon } from '@heroicons/react/24/outline'
import { Avatar } from '../catalyst/avatar'
import { Dropdown, DropdownButton, DropdownDivider, DropdownItem, DropdownLabel, DropdownMenu } from '../catalyst/dropdown'
import { NavbarItem } from '../catalyst/navbar'
import { SidebarItem } from '../catalyst/sidebar'
import { initialsFor, useAuth } from '../lib/auth'
import { ADMIN_URL } from '../lib/links'
import { useTheme } from '../lib/theme'

const avatarClass = 'bg-zinc-950 text-white dark:bg-white dark:text-zinc-950'

export function AccountMenu({ variant }: { variant: 'sidebar' | 'navbar' }) {
  const { theme, toggle } = useTheme()
  const { user, signOut } = useAuth()
  const isDark = theme === 'dark'
  const initials = user ? initialsFor(user.name) : 'U'

  const menuItems = (
    <>
      <DropdownItem href="/settings">
        <Cog6ToothIcon data-slot="icon" />
        <DropdownLabel>Settings</DropdownLabel>
      </DropdownItem>
      {user?.isStaff === true && (
        <DropdownItem href={ADMIN_URL}>
          <WrenchScrewdriverIcon data-slot="icon" />
          <DropdownLabel>Farmula admin</DropdownLabel>
        </DropdownItem>
      )}
      <DropdownItem onClick={toggle}>
        {isDark ? <SunIcon data-slot="icon" /> : <MoonIcon data-slot="icon" />}
        <DropdownLabel>{isDark ? 'Light mode' : 'Dark mode'}</DropdownLabel>
      </DropdownItem>
      <DropdownDivider />
      <DropdownItem onClick={() => void signOut()}>
        <ArrowRightStartOnRectangleIcon data-slot="icon" />
        <DropdownLabel>Sign out</DropdownLabel>
      </DropdownItem>
    </>
  )

  if (variant === 'sidebar') {
    return (
      <Dropdown>
        <DropdownButton as={SidebarItem}>
          <span className="flex min-w-0 items-center gap-3">
            <Avatar initials={initials} square className={`size-10 ${avatarClass}`} alt="" />
            <span className="min-w-0">
              <span className="block truncate text-sm/5 font-medium text-zinc-950 dark:text-white">{user?.name ?? 'Account'}</span>
              <span className="block truncate text-xs/5 font-normal text-zinc-500 dark:text-zinc-400">{user?.email ?? ''}</span>
            </span>
          </span>
          <ChevronUpIcon data-slot="icon" />
        </DropdownButton>
        <DropdownMenu className="min-w-64" anchor="top start">
          {menuItems}
        </DropdownMenu>
      </Dropdown>
    )
  }

  return (
    <Dropdown>
      <DropdownButton as={NavbarItem} aria-label="Account">
        <Avatar initials={initials} square className={avatarClass} />
      </DropdownButton>
      <DropdownMenu className="min-w-64" anchor="bottom end">
        {menuItems}
      </DropdownMenu>
    </Dropdown>
  )
}
